<template>
    <div class="delivery">
        <p>
            {{ $t('deliveries.desc') }}
        </p>

        <XmasDelivery
            v-if="xmasDelivery?.isEnabled && !data?.find((del) => del.shippingFullType === 'DEL_EMAIL')"
            :guarantee="xmasDelivery?.isGuaranteed"
            :text="xmasDelivery?.message"
        />

        <div v-if="data" class="delivery-skelet table-wrapper">
            <table v-if="loading">
                <tr v-for="index in 7" :key="index">
                    <td>&nbsp;</td>
                </tr>
            </table>
            <table v-else>
                <tbody>
                    <tr v-for="(item, key) in data" :id="`delivery-${item.id}`" :key="key">
                        <td>
                            {{ item.name }}
                            <!--<a
                                v-if="item.id === 1 || item.id === 8"
                                class="d-block d-sm-inline text-primary small ml-sm-2"
                                href="/pilulka-lekarny?samplingPoint=1#anchor-pilulka-pharmacies"
                                >{{ $t('deliveries.pharmacies') }}</a
                            >
                            <a
                                v-if="item.id === 2"
                                class="d-block d-sm-inline text-primary small ml-sm-2"
                                href="/mapa-odbernych-mist?map-type=zasilkovna&amp;page=1"
                                >{{ $t('deliveries.zasilkovna') }}</a
                            >-->
                            <!--                            <br v-if="item.description" /><span v-if="item.description" class="fs-12">{{ item.description }}</span>-->
                        </td>
                        <td class="text-right">
                            <span class="text-success text-nowrap">{{ item.availability }}</span>
                            <br />
                            <span class="text-primary text-nowrap">{{ $formatCurrency(item.fee) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="alert alert-danger px-5">{{ $t('error') }}</div>
    </div>
</template>

<script lang="ts">
// import { BSkeletonTable } from 'bootstrap-vue'
import XmasDelivery from '~/components/objects/XmasDelivery.vue'
import ProductXmasDelivery from '~/models/Product/ProductXmasDelivery'

export default {
    components: {
        // BSkeletonTable,
        XmasDelivery,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            data: [] as {
                name: string
                shippingFullType: string
                availability: string
                id: number
                inStock: number
                inStockExpeditionTime: string | null
                outOfStockExpeditionTime: string | null
                inStockDeliveryTime: string | null
                outOfStockDeliveryTime: string | null
                fee: number
            }[],
            xmasDelivery: {} as ProductXmasDelivery,
            loading: true,
        }
    },

    async mounted() {
        await this.fetch()
    },

    methods: {
        async fetch(): Promise<void> {
            const response = await this.$repository.getProductDetailData(this.productId)
            this.data = response.product.deliveries
            this.xmasDelivery = response.product?.xmasDelivery
            this.loading = false
        },
    },
}
</script>

<style lang="scss">
.delivery-skelet {
    table tbody {
        tr {
            td:nth-child(2) {
                .b-skeleton-text {
                    float: right;
                    max-width: 30%;
                }
            }
        }
    }
}

.modal-deliveries {
    .modal-body {
        padding: 0;
    }

    .modal-dialog {
        max-width: 550px;
    }

    &.modal {
        .modal-content {
            overflow: hidden;
            box-shadow: none;
        }

        .modal-title {
            font-size: 16px;
        }
    }

    .modal-content {
        .table-wrapper {
            margin: 0 -1.5em -1.5em;

            td {
                border-width: 0;
            }
        }

        table {
            width: 100%;
            font-weight: 500;
            margin-bottom: 10px;

            tr {
                background-color: $color-grey;
            }

            tr:nth-child(even) {
                background-color: transparent;
            }

            td {
                padding: 0.75em 1.5em;

                @media (max-width: 480px) {
                    margin-bottom: -1.5em;
                    padding: 0.75em 1.5em;
                }
            }
        }
    }
}
</style>
